<style lang="less" scoped>
.worker-edit-page {
  width: 100%;
  height: 100%;
}
.worker-edit-page-c {
  margin: 10px;
  width: calc(100% - 20px);
  height: calc(100% - 20px);
  background: #fff;
  position: relative;
  .edit-user-form-content {
    width: 100%;
    height: 100%;
  }
  .c-b {
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 28px;
    padding: 20px;
  }
  .c-c {
    overflow-y: auto;
  }
}
.c-t {
  opacity: 0;
  width: 100%;
}
.c-t-show {
  opacity: 1;
}
</style>

<template>
  <div class="worker-edit-page">
    <div class="worker-edit-page-c">
    <div class="edit-user-form-content" v-loadingx="loading">
      <fm-title title-text="员工信息维护" :titleMenus="chooseWorkerId ? [{key: 'batch', label: '批量维护'}, {key: 'showAll', label: '总览'}] : [{key: 'batch', label: '批量维护'}]" @clickTitleMenu="clickTitleMenu">
        <dir style="display: flex;justify-content: space-between;align-items: center; flex: 1;">
          <div>
          <fm-select
            filterable
            v-model="chooseWorkerId"
            block
            v-show="workerList && workerList.length > 0 && (workerList.length > 1 || workerList[0].data.id !== Number(workerId))"
            :clearable="false">
            <fm-option v-for="option in workerList" :label="option.label" :value="option.key" :key="option.key"></fm-option>
          </fm-select>
          </div>
          <progress-bar v-if="!changeIng && chooseWorkerId" :value="progressValue"/>
        </dir>
      </fm-title>
      <div class="c-t" ref="stepList" :class="{'c-t-show': !changeIng && chooseWorkerId}" style="margin-top: 10px;">
        <step @setStep="setStep" :cStep="cStep.key" :steps="steps" :completeness="completeness"></step>
      </div>
      <div class="c-c" :style="pageCenterStyle" v-if="!changeIng && chooseWorkerId">
        <component
          :display="cStep.key === step.key"
          :key="step.key"
          v-for="(step, index) in steps"
          :is-real="true"
          :ref="'efcmp' + index" :is="step.cmp"
          :worker-id="chooseWorkerId"
          :is-absolut="isAbsolut"
          @completeness="v => completenessChange(step.key, v)"></component>
      </div>
      <div class="c-b" v-if="!changeIng && chooseWorkerId">
        <fm-btn style="margin: 0 20px;" @click="save" v-if="cStep.key !== 'idcard'">保存</fm-btn>
        <fm-btn style="margin: 0 20px;" @click="next(-1)" v-if="cStepIndex > 0">上一步</fm-btn>
        <fm-btn style="margin: 0 20px;" @click="next(1)" v-if="cStepIndex < steps.length - 1">下一步</fm-btn>
      </div>
    </div>
    </div>
    <fm-modal class="all-info" :mask-closable="true" v-model="showAll" width="80%" v-if="showAll">
      <div slot="header" style="text-align: center;margin-bottom: 20px;font-size: 25px;">个人信息总览</div>
      <allInfo :worker-id="chooseWorkerId"></allInfo>
    </fm-modal>
    <fm-modal :mask-closable="false" v-model="showBatch" width="80%" v-if="showBatch">
      <batch-update :worker-list="workerList.map(v => v.data)"></batch-update>
    </fm-modal>
    <data-apply-log v-model="showLog" :show-tool-box="showToolBox" />
  </div>
</template>

<script>
import WorkerDataBase from './cmp/workerDataBase'
import WorkerDataWork from './cmp/workerDataWork'
import EduData from './cmp/eduData'
import HisWorkData from './cmp/hisWorkData'
import Rew from './cmp/rew'
import Train from './cmp/train'
import CertificateData from './cmp/certificateData'
import CertificateDataDoctorPra from './cmp/certificateDataDoctorPra'
import CertificateDataDoctorQua from './cmp/certificateDataDoctorQua'
import CertificateDataOther from './cmp/certificateDataOther'
import CertificateDataProHire from './cmp/certificateDataProHire'
import JobTitleData from './cmp/jobTitleData'
import WorkerIdCard from './cmp/workerIdCard'
import BatchUpdate from '../../worker/worker/batchUpdate'

import AllInfo from '../info/allInfo'

import Step from './step'
import ProgressBar from './progress.vue'

import DataApplyLog from '../../../components/data-apply/modal'

let steps = Object.freeze([{
  key: 'base',
  label: '基础信息',
  cmp: WorkerDataBase,
},
{
  key: 'work',
  label: '工作信息',
  cmp: WorkerDataWork
},
{
  key: 'work_id_card',
  label: '身份证',
  cmp: WorkerIdCard
},
{
  key: 'edu_data',
  label: '教育经历',
  cmp: EduData
},
{
  key: 'his_work',
  label: '工作经历',
  cmp: HisWorkData
},
{
  key: 'rew',
  label: '奖励信息',
  cmp: Rew
},
{
  key: 'train',
  label: '培训与进修信息',
  cmp: Train
},
{
  key: 'cf',
  label: '专业技术资格证书',
  cmp: CertificateData
},
{
  key: 'doctor_pra',
  label: '执业证书',
  cmp: CertificateDataDoctorPra
},
{
  key: 'doctor_que',
  label: '职业资格证书',
  cmp: CertificateDataDoctorQua
},
{
  key: 'job_title',
  label: '职称聘任记录',
  cmp: JobTitleData
},
{
  key: 'pro_hire',
  label: '专业技术职务聘任证书',
  cmp: CertificateDataProHire
},
{
  key: 'other',
  label: '其他证书',
  cmp: CertificateDataOther
}])

export default {
  components: {
    Step,
    AllInfo,
    ProgressBar,
    DataApplyLog,
    BatchUpdate
  },
  data () {
    return {
      changeIng: false,
      chooseWorkerId: this.workerId,
      cStep: steps[0],
      steps: steps,
      showAll: false,
      showLog: false,
      completeness: {},
      loading: false,
      pageCenterStyle: {},
      showBatch: false
    }
  },
  watch: {
    chooseWorkerId () {
      this.changeIng = true
      this.$nextTick(() => {
        this.changeIng = false
      })
      this.cStep = this.steps[0]
      this.completeness = {}
    }
  },
  async created () {
    this.$store.dispatch('loadWorkerList')
  },
  mounted () {
    let used = this.$refs.stepList.clientHeight + 48 + 64
    this.pageCenterStyle = {
      height: 'calc(100% - ' + used + 'px)'
    }
  },
  computed: {
    workerList () {
      return this.$store.getters.workerList
    },
    showToolBox () {
      return ['table-export', 'table-config'].filter(v => this.$authFunsProxy[v]).map(v => v.replace('table-', ''))
    },
    cStepIndex () {
      return this.steps.indexOf(this.cStep)
    },
    progressValue () {
      let keys = Object.keys(this.completeness)
      let value = keys.reduce((a, b) => a + this.completeness[b], 0)
      value = Number((value / keys.length * 100).toFixed(0))
      return isNaN(value) ? 0 : value
    }
  },
  props: {
    workerId: {
      type: [String, Number]
    },
    openDialog: {
      type: Boolean
    },
    isAbsolut: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    completenessChange (key, v) {
      this.$set(this.completeness, key, Number(v.toFixed(2)))
    },
    clickTitleMenu (key) {
      if (key === 'showAll') {
        this.showAll = true
      } else if (key === 'log') {
        this.showLog = true
      } else if (key === 'batch') {
        this.showBatch = true
      }
    },
    async save () {
      let vm = this.$refs['efcmp' + this.cStepIndex][0]
      if (typeof vm.save === 'function') {
        this.loading = true
        try {
          await vm.save()
          this.loading = false
        } catch (e) {
          console.log(e)
          this.loading = false
        }
      }
    },
    async submit () {
      let vm = this.$refs['efcmp' + this.cStepIndex][0]
      if (typeof vm.submit === 'function') {
        this.loading = true
        try {
          await vm.submit()
          this.loading = false
        } catch (e) {
          console.log(e)
          this.loading = false
        }
      }
    },
    check () {
      let ok = true
      if (this.$refs['efcmp']) {
        let vm = this.$refs['efcmp' + this.cStepIndex][0]
        if (typeof vm.testEdited === 'function' && vm.testEdited()) {
          this.$notice.info({
            title: '系统提示',
            desc: '请保存后再进入下一步'
          })
          ok = false
        }
      }
      return ok
    },
    next (nIndex) {
      if (this.check()) {
        this.cStep = this.steps[this.cStepIndex + nIndex]
        if (this.$refs['efcmp' + this.cStepIndex][0].loadData) {
          this.$refs['efcmp' + this.cStepIndex][0].loadData()
        }
      }
    },
    setStep (i) {
      if (this.check()) {
        this.cStep = this.steps[i]
        if (this.$refs['efcmp' + this.cStepIndex][0].loadData) {
          this.$refs['efcmp' + this.cStepIndex][0].loadData()
        }
      }
    }
  }
}
</script>
